import React, { useState } from "react";
import flowProducts from "../../data/FlowData"; // ✅ Correct dataset for Flow Meters
import PriceModal from "../../components/PriceModal";
import DatasheetModal from "../../components/DatasheetModal";
import "./Flow.css"; // ✅ Separate CSS for Flow

function FlowPage() {
  const [selectedSensor, setSelectedSensor] = useState(null);
  const [datasheetSensor, setDatasheetSensor] = useState(null);

  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">Flow Meters</h2>
      <div className="row">
        {flowProducts.map((product) => (
          <div className="col-md-4 mb-4" key={product.id}>
            <div className="card sensor-card">
              <img
                src={product.image}
                className="card-img-top"
                alt={product.name}
              />
              <div className="card-body">
                <h5 className="card-title">{product.name}</h5>
                <p className="card-text">{product.description}</p>

                {/* Buttons Row */}
                <div className="d-flex justify-content-between">
                  {/* Left: View Price */}
                  <button
                    className="btn btn-sm btn-success"
                    onClick={() => setSelectedSensor(product)}
                  >
                    View Price
                  </button>

                  {/* Right: View PDF */}
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => setDatasheetSensor(product)}
                  >
                    View Datasheet
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Price Modal */}
      {selectedSensor && (
        <PriceModal
          sensor={selectedSensor}
          onClose={() => setSelectedSensor(null)}
        />
      )}

      {/* Datasheet Modal */}
      {datasheetSensor && (
        <DatasheetModal
          sensor={datasheetSensor}
          onClose={() => setDatasheetSensor(null)}
        />
      )}
    </div>
  );
}

export default FlowPage;  // ✅ Correct export
